import {
  mockMyAssetsManageItems,
  mockMyAssetsManageSummary,
  mockMyAssetsSummary,
} from '@/__mocks__';

const myAssetsApi = {
  requestSummary() {
    return new Promise((resolve) => {
      setTimeout(() => {
        const summary = { data: mockMyAssetsSummary() };
        resolve(summary);
      }, 100);
    });
  },
  requestManageList() {
    return new Promise((resolve) => {
      const txs = 10;
      setTimeout(() => {
        const items = {
          data: {
            txs: mockMyAssetsManageItems(txs),
            paging: {
              next_cursor: 'MjAyMS0wOC0wMVQxNToyNTo0OS4zODg3MjNa',
              next_link:
                'https://localhost/items?cursor=MjAyMS0wOC0wMVQxNToyNTo0OS4zODg3MjNa',
              total_count: txs,
            },
          },
        };
        resolve(items);
      }, 100);
    });
  },
  requestManageSummary() {
    return new Promise((resolve) => {
      setTimeout(() => {
        const summary = { data: mockMyAssetsManageSummary() };
        resolve(summary);
      }, 100);
    });
  },
};

export default myAssetsApi;
